import { useNavigate } from "react-router-dom";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA] dark:bg-zinc-950 p-6">
      <div data-testid="payment-cancel" className="nb-card p-10 max-w-md text-center nb-shadow-xl">
        <div className="font-display text-3xl font-extrabold mb-2">No worries</div>
        <p className="text-zinc-600 dark:text-zinc-400 font-medium mb-6">
          You can subscribe whenever you&apos;re ready. Free tier still works.
        </p>
        <div className="flex gap-3 justify-center">
          <button onClick={() => navigate("/pricing")} className="nb-button px-5 py-3">Back to pricing</button>
          <button onClick={() => navigate("/")} className="nb-button px-5 py-3 bg-[#D4C4FB] dark:bg-[#B794F4]">Continue free</button>
        </div>
      </div>
    </div>
  );
}
